import { Component, OnInit } from '@angular/core';
import { FormApiService } from '@app/core/services/form-api.service';
import { MeteringPointService, MeteringPointStopDto } from '@app/api/dmc';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';

@Component({
  selector: 'app-close-meteringpoint',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    TranslatePipe,
    LabelDirective,
    InputDirective
  ],
  templateUrl: './close-meteringpoint.component.html',
  styleUrl: './close-meteringpoint.component.css'
})
export class CloseMeteringpointComponent implements OnInit {
  public form: FormGroup = new FormGroup({
    meteringPointIdentification: new FormControl<string | undefined>(undefined, Validators.required),
    occurrence: new FormControl<string | undefined>(undefined, [Validators.required]),
  });

  /** ID **/
  public id?: string;

  constructor(
    private readonly formApiService: FormApiService,
    private readonly meteringPointService: MeteringPointService,
  ) { }

  public ngOnInit(): void {
    this.form.get('meteringPointIdentification')?.setValue(this.id);
  }

  public submit(): void {
    this.form.get('meteringPointIdentification')?.setValue(this.id);

    this.formApiService.submit<MeteringPointStopDto>(
      this.form,
      (data) => this.meteringPointService.meteringPointStopMeteringPointPut(data),
      {
        successMessage: 'Nedlægning gemt',
        closeModal: true,
      }
    )


  }

}
